module.exports = __webpack_public_path__ + "img/job-seeker.7e788ebd.png";